import React from 'react';
import { connect } from 'react-redux';

import { CommonPagePromo } from 'components/no-auth/common/CommonPagePromo';
import { LightHeaderPanel } from 'components/no-auth/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { LightIcon } from 'components/no-auth/common/fromAuth/LightIcon/LightIcon';
import { LightText } from 'components/no-auth/common/fromAuth/LightText/LightText';
import { MobileHelpLink } from 'components/no-auth/help/styles';
import ZendeskHelpMobileSearch from 'components/no-auth/help/ZendeskHelpMobileSearch';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'components/no-auth/utils';

import { toggleSpinner } from 'actions/appAction';

import { getLangCountryPrefix } from 'helpers/utils';

const ZendeskHelpMobilePage = (props) => {
    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;
    const urlParams = useGetQueryParams();

    const filteredCategories = props.categories?.filter((category) => {
        return !category.directLink;
    });

    const categories = filteredCategories?.map((item) => {
        return (
            <MobileHelpLink key={item.id} href={getHelpCenterUrl(`${url}/category/${item.id}`, urlParams)}>
                <LightText useThemeColor>{item.name}</LightText>
                <LightIcon useThemeColor name="chevron-right" color={'purple'} leftIndent={'16px'} />
            </MobileHelpLink>
        );
    });

    return (
        <CommonPagePromo
            backUrl={!urlParams.platform ? props.backUrl : null}
            type={'tagA'}
            leftCloseIcon
            useThemeColor
            onClickIcon={() => {
                props.toggleSpinner(true);
                sessionStorage?.removeItem('prevUrl');
            }}
        >
            <LightHeaderPanel useThemeColor title={props.pageHeadline} />
            <ZendeskHelpMobileSearch isMobilePlatform={urlParams.platform === 'ios' || urlParams.platform === 'android'} />
            {categories}
        </CommonPagePromo>
    );
};

const mapStateToProps = ({ extra }) => ({
    pageHeadline: extra?.strapiApi?.page_headline_mobile?.title,
    categories: extra?.zendeskHelpData?.categories,
    sections: extra?.zendeskHelpData?.sections,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleSpinner })(NotAuthBasePage(ZendeskHelpMobilePage));
